import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import extractText from 'flarum/common/utils/extractText';
import Avatar from 'ext:ernestdefoe/parley/forum/components/Avatar';
import RoomTile from 'ext:ernestdefoe/parley/forum/components/RoomTile';
import Icons from '../icons';
const t = (key, params) => app.translator.trans('ernestdefoe-parley-calls.forum.voice.' + key, params);

/**
 * In voice with the room's window closed: a small card that keeps you there
 * while you read the forum, with mute, leave, and the way back to the room.
 * A room another extension owns has no window; it passes `href`, the page the
 * voice chat belongs to, and sets `onScreen` while its own controls are showing.
 */
export default class VoicePill extends Component {
  view() {
    const v = app.parleyVoice;
    const s = v.session;
    const room = {
      ...(s.room || {}),
      ...(app.parley.room(s.roomId) || {})
    };
    const people = [...s.roster.values()];
    return m("div", {
      className: "pl-voice-pill",
      role: "region",
      "aria-label": extractText(t('pill_label', {
        name: room.name
      }))
    }, m("button", {
      className: "pl-voice-pill-room",
      onclick: () => room.href ? m.route.set(room.href) : app.parley.openRoom(s.roomId),
      title: extractText(t(room.href ? 'go_back' : 'open_room'))
    }, RoomTile(room, 28), m("span", null, m("b", null, room.name), m("small", null, t('in_here', {
      count: people.length
    })))), m("div", {
      className: "pl-voice-faces"
    }, people.slice(0, 6).map(p => m("span", {
      className: 'pl-voice-face' + (s.speaking.has(p.id) ? ' speaking' : '') + (p.muted ? ' muted' : ''),
      title: p.displayName
    }, Avatar(p, 22)))), m("button", {
      className: 'pl-cb' + (s.muted ? ' on' : ''),
      "aria-pressed": String(s.muted),
      "aria-label": extractText(t(s.muted ? 'unmute' : 'mute')),
      onclick: () => s.toggleMute()
    }, s.muted ? Icons.micoff(16) : Icons.mic(16)), m("button", {
      className: "pl-cb end",
      "aria-label": extractText(t('leave')),
      title: extractText(t('leave')),
      onclick: () => v.leave()
    }, Icons.end()));
  }
}
flarum.reg.add('ernestdefoe-parley-calls', 'forum/components/VoicePill', VoicePill);